<form [formGroup]="carrierCtrl">
	<mat-form-field class="full-width" floatLabel="never">
		<input
			#carrierInput
			[formControl]="carrierCtrl"
			[matAutocomplete]="auto"
			matInput
			placeholder="Carrier"
		/>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event)"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoading" fxLayoutAlign="center center">
				<mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoading">
				<mat-option *ngFor="let carrier of listOfCarriers" [value]="carrier">
					{{ !utilService.isNullOrUndefined(carrier.businessName) ? carrier.businessName : '' }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</form>
